import React from 'react';
import _ from 'lodash';
import {
	withStyles,
	Theme,
	createStyles,
	WithStyles,
	Grid,
	Typography,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Avatar,
	Card,
	CardContent
} from '@material-ui/core';
import UserProfileBody from '../types/UserProfileBody';

const styles = (theme: Theme) => createStyles({
	cardContentRoot: {
		position: 'relative',
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},

	profileAvatar: {
		height: theme.spacing.unit * 25,
		width: theme.spacing.unit * 25,
	},
	roleName: {
		textTransform: 'capitalize',
		marginRight: theme.spacing.unit / 2,
		'&:after': {
			content: '","',
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				display: 'none',
			},
		}
	},
	profileTable: {
		width: 'auto',
		'& tbody': {
			'& tr': {
				height: 'auto',
				'& td': {
					fontSize: theme.typography.body1.fontSize,
					border: 0,
					padding: 0,
					paddingTop: theme.spacing.unit / 2,
					paddingBottom: theme.spacing.unit / 2,
					color: theme.palette.text.secondary,
					'&:first-child': {
						fontWeight: theme.typography.fontWeightMedium,
						paddingRight: theme.spacing.unit,
						color: theme.palette.text.primary,
					}
				}
			}
		}
	},
});

interface ProfileCardProps extends WithStyles<typeof styles> {
	userProfile: UserProfileBody,
}

const ProfileCard = (props: ProfileCardProps) => {
	const { classes, userProfile } = props;
	return (
		<Card>
			<CardContent className={classes.cardContentRoot}>
				<Grid container alignItems="center" spacing={16}>
					<Grid item xs="auto">
						<Avatar className={classes.profileAvatar} alt={`Profile ${userProfile.fullName}`} src={_.isEmpty(userProfile.profileImage) ? "/assets/img/profile-default.png" : userProfile.profileImage} />
					</Grid>
					<Grid item xs>
						<Typography variant="h5">
							<strong>{_.get(userProfile, 'fullName', '')}</strong>
						</Typography>
						<Table className={classes.profileTable}>
							<TableBody>
								<TableRow>
									<TableCell>
										Role:
									</TableCell>
									<TableCell>
										{_.map(userProfile.roles, (role, i) => <span key={`role-${i}`} className={classes.roleName}>{_.get(role, 'roleId.role', '')}</span>)}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										Email:
									</TableCell>
									<TableCell>
										{(_.isUndefined(userProfile.userName) || _.isEmpty(userProfile.userName))
											? _.get(userProfile, 'email', '')
											: _.get(userProfile, 'userName', '')
										}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										Mobile No:
									</TableCell>
									<TableCell>
										{_.get(userProfile, 'phone', '')}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										Organization:
									</TableCell>
									<TableCell>
										Glorifire
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
}

export default withStyles(styles)(ProfileCard);